export interface JsonViewProps {
  data: any;
}

export function JsonView({ data }: JsonViewProps) {
  return (
    <pre className="my-3 p-3 bg-faded">{JSON.stringify(data, null, 2)}</pre>
  );
}
